import { Button, Input } from '@/fsd/shared/ui';
import Modal from '@/fsd/shared/ui/Modal/Modal';
import { Plus } from 'lucide-react';
import { Dispatch, MutableRefObject, Ref, SetStateAction } from 'react';
import { CabinetApi } from '../../api';
import { cabinetHandleRefresh } from '../../lib/helpers/cabinetHandlerRefresh';
import { ICabinetModalType } from '../../model/types/ICabinetModalType';
import styles from './CabinetModal.module.scss';

interface IProps {
  openModal: boolean;
  handleCloseModal: () => void;
  titleText: string;
  contentText?: string;
  typeModal: MutableRefObject<ICabinetModalType>;
  newCabinetName: string;
  setNewCabinetName: Dispatch<SetStateAction<IProps['newCabinetName']>>;
  handleCreateCabinet?: () => Promise<void>;
  handleChangeName?: () => Promise<void>;
  handleRemoveCabinet?: () => Promise<void>;
}

export const CabinetModal = ({
  openModal,
  handleCloseModal,
  titleText,
  contentText,
  typeModal,
  newCabinetName,
  setNewCabinetName,
  handleCreateCabinet,
  handleChangeName,
  handleRemoveCabinet,
}: IProps) => {
  return (
    <Modal
      showModal={openModal}
      setShowModal={handleCloseModal}
      showCloseButton={true}
      height="fit-content"
    >
      <h2 className={styles.modalTitle}>{titleText}</h2>
      {contentText && <div>{contentText}</div>}
      <>
        {typeModal.current === 'create' && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              gap: '18px',
            }}
          >
            <Input
              placeholder="Введите название кабинета"
              value={newCabinetName}
              onChange={(e) => setNewCabinetName(e.currentTarget.value)}
            />
            <div
              style={{
                display: 'flex',
                justifyContent: 'end',
                gap: '10px',
              }}
            >
              <Button
                variant="outline"
                width="fit-content"
                size="l"
                style={{ justifyContent: 'center' }}
                onClick={handleCloseModal}
              >
                Отмена
              </Button>
              <Button
                style={{ justifyContent: 'center', gap: '14px' }}
                width="fit-content"
                size="l"
                onClick={handleCreateCabinet}
              >
                <Plus width={20} height={20} /> Добавить
              </Button>
            </div>
          </div>
        )}
        {typeModal.current === 'rename' && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              gap: '18px',
            }}
          >
            <Input
              value={newCabinetName}
              onChange={(e) => setNewCabinetName(e.currentTarget.value)}
            />
            <div
              style={{
                display: 'flex',
                justifyContent: 'end',
                gap: '10px',
              }}
            >
              <Button
                variant="outline"
                width="fit-content"
                size="l"
                style={{ justifyContent: 'center' }}
                onClick={handleCloseModal}
              >
                Отмена
              </Button>
              <Button
                width="fit-content"
                size="l"
                style={{ justifyContent: 'center' }}
                onClick={handleChangeName}
              >
                Переименовать
              </Button>
            </div>
          </div>
        )}
        {typeModal.current === 'remove' && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'end',
              gap: '10px',
              width: '100%',
            }}
          >
            <Button
              width="fit-content"
              size="l"
              style={{ justifyContent: 'center' }}
              onClick={handleRemoveCabinet}
            >
              Удалить
            </Button>
            <Button
              width="fit-content"
              size="l"
              variant="outline"
              style={{ justifyContent: 'center' }}
              onClick={handleCloseModal}
            >
              Отмена
            </Button>
          </div>
        )}
      </>
    </Modal>
  );
};
